import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { CrudViewComponent } from '../../../shared/components/crud/view/view';
import { PlanInterface } from '../../../models/plan.model';
import { PlanesService } from '../../../core/planes.service';
import { BaseCrud, typeAction } from '../../../shared/baseCrud.component';
import { PLANES_COLUMN_NAMES } from '../../../constants/planes.constants';

@Component({
  selector: 'app-planes-view',
  imports: [CommonModule, MatListModule, CrudViewComponent],
  templateUrl: './planes-view.html',
  styleUrls: ['./planes-view.scss']
})
export class PlanesViewComponent extends BaseCrud<PlanInterface> {
  type = <typeAction>'view';
  apiService = new PlanesService;
  columnNames = PLANES_COLUMN_NAMES
}
